import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useCreateVideoCallMutation as useCreateVideoCallMutationType } from "@/modules/video-call/services/__generated__/useCreateVideoCallMutation.graphql"

export interface VideoCallRoom {
  accessToken: string
  roomSid: string
  dummyToken?: string
}

const createVideoCallMutation = graphql`
  mutation useCreateVideoCallMutation($input: StartVideoCallInput!) {
    startVideoCall(input: $input) {
      startVideoCallOutput {
        roomSid
        sofiaUserToken
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`

const useCreateVideoCallMutation = () => {
  const [commit, isFlight] = useMutation<useCreateVideoCallMutationType>(createVideoCallMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCreateVideoCallMutationType>) => {
      commit(config)
    },
    [commit],
  )
  return [commitHandler, isFlight] as const
}

export { useCreateVideoCallMutation }
